<template>
    <div>
        <el-empty description="" v-show="!isChartShow"></el-empty>
        <div v-if="chartData!=undefined" :id="chartData.chartid" style="position:relative;">
        </div>
    </div>
    
</template>

<script>
    import * as d3 from 'd3'

    export default {
        name: 'Contourplot',
        props: {
            chartData: {
                type: Object
            }
        },
        data() {
            return {
                isChartShow: false
            }
        },
        watch: {
            chartData: {//深度监听，可监听到对象、数组的变化
                handler(newVal) {
                    if (newVal) {
                        this.$nextTick(() => {
                            let contour_data = this.parse_pdata(newVal.pdata);
                            this.isChartShow = false;
                            if (contour_data.length > 0) {
                                this.make_contour("#" + this.chartData.chartid, newVal.size, d3.transpose(contour_data), [250, 650], [220, 500], newVal.peaks);
                                this.isChartShow = true;
                            }
                        });
                    }
                },
                deep: true //true 深度监听
            }
        },
        computed: {           
        },
        created() {
            
        },
        methods: {
            parse_pdata(pdata){
                let data = []
                if (pdata != null)
                pdata.forEach(line => {
                    let line_data = []
                    let items = line.split(',')
                    items.forEach(item => line_data.push(item * 1.))
                    data.push(line_data)
                })
                return data
            },
            make_contour(container_id,size, data, x_domain, y_domain, peaks, levels = 8) {
                let container = d3.select(container_id)
                //let rect = container.node().getBoundingClientRect()
                container.html('');
                let svg = container.append("svg")
                    .style("height", size.height + "px")
                    .style("width", size.width + "px")
                const contour_size = {
                    width: size.width,
                    height: size.height,
                    contour_top: 10,
                    contour_left: 80,
                    contour_bottom: 40,
                    contour_right: 50
                }
                contour_size.contour_width = contour_size.width - contour_size.contour_left - contour_size.contour_right
                contour_size.contour_height = contour_size.height - contour_size.contour_top - contour_size.contour_bottom
                // 4部分：
                // 1、坐标轴
                this.axis_g(svg, contour_size, x_domain, y_domain)
                // 2、等高线图
                const value_domain = this.contour_g(svg, data, contour_size, levels)
                // 3、Color Bar
                this.colorbar_g(svg, value_domain, contour_size)
                // 4、峰值信息
                this.peak_g(svg, peaks, x_domain, y_domain, contour_size)
            },
            axis_g(svg, contour_size, x_domain, y_domain){
                // xAxis and yAxis
                let xAxis = d3.scaleLinear()
                    .domain(x_domain)
                    .range([0, contour_size.contour_width]);
                svg.append("g")
                    .attr("class", "axis")
                    .attr("transform", `translate(${contour_size.contour_left},${contour_size.contour_height + contour_size.contour_top})`)
                    .call(d3.axisBottom(xAxis));
                let yAxis = d3.scaleLinear()
                    .domain(y_domain)
                    .range([contour_size.contour_height, 0]);
                svg.append("g")
                    .attr("class", "axis")
                    .attr("transform", `translate(${contour_size.contour_left},${contour_size.contour_top})`)
                    .call(d3.axisLeft(yAxis));

                svg.append("text")
                    .attr("class", "x label")
                    .attr("text-anchor", "end")
                    .attr("x", 30 + contour_size.contour_left + contour_size.contour_width / 2)
                    .attr("y", contour_size.height)
                    .text("Em. (nm)");
                svg.append("text")
                    .attr("class", "y label")
                    .attr("text-anchor", "end")
                    .attr("y", 30)
                    .attr("x", 15 -contour_size.contour_height/2)
                    .attr("dy", ".75em")
                    .attr("transform", "rotate(-90)")
                    .text("Ex. (nm)");
            },
            contour_g(svg, data, contour_size, levels = 8) {
                //2022.02.25 转置数组
                data = d3.transpose(data)
                let y_length = data.length
                let x_length = data[0].length
                let step = 10
                let map_height = step * levels
                let map_data = []
                d3.reverse(data).forEach(line => {
                    line.forEach(item => map_data.push(item))
                })
                const max_data = d3.max(map_data)
                let map_radio = map_height / max_data
                for (let i = 0; i < map_data.length; i++) {
                    map_data[i] = map_data[i] * map_radio
                }
                let color = d3.scaleSequential([0, map_height], d3.interpolateGreens)
                let g = svg.append('g')
                g.selectAll("path")
                    .data(d3.contours().size([x_length, y_length]).thresholds(d3.range(0, map_height + 1, step))(map_data))
                    .enter().append("path")
                    .attr("d", d3.geoPath(d3.geoIdentity().scale(contour_size.contour_width / x_length)))
                    .attr("fill", function (d) {
                        // if(d.value == 0) return "#fff"
                        return color(d.value);
                    });

                g.selectAll("path").attr("transform", `scale(1,${contour_size.contour_height * x_length / contour_size.contour_width / y_length})`)
                g.attr("transform", `translate(${contour_size.contour_left},${contour_size.contour_top})`)
                g.attr("height", `${contour_size.contour_height}`)
                g.attr("width", `${contour_size.contour_width}`)
                g.attr("stroke", "#000")
                g.attr("stroke-width", "0.1")//线条粗细
                return [0, max_data]
            },
            colorbar_g(svg, value_domain, contour_size) {
                let translate_x = -(contour_size.contour_top + contour_size.contour_height);
                let translate_y = contour_size.contour_left + contour_size.contour_width;
                let colorbar = this.legend(svg, {
                    color: d3.scaleSequential(value_domain, d3.interpolateGreens),
                    rotation: -90,
                    width: contour_size.contour_height,
                    height: contour_size.contour_right,
                    translate_x: translate_x,
                    translate_y: translate_y,
                })
                // colorbar.attr("transform", `translate(${height},0)`)
                svg.append(() => colorbar.node())
            },
            peak_g(svg, peaks, x_domain, y_domain, contour_size) {
                if (d3.select("div#hx_tooltip").empty()) this.add_tooltip()
                let x_scale = d3.scaleLinear()
                    .domain(x_domain)
                    .range([0, contour_size.contour_width]);
                let y_scale = d3.scaleLinear()
                    .domain(y_domain)
                    .range([contour_size.contour_height, 0])
                function convert_coordinate(original_coor) {
                    return [x_scale(original_coor[0]) + contour_size.contour_left, y_scale(original_coor[1]) + contour_size.contour_top]
                }
                for (let i = 0; i < peaks.length; i++) {
                    // peak = peaks[i]
                    this.add_polygon(svg, peaks[i], convert_coordinate, i)
                }
                // peaks.forEach(peak=>add_polygon(svg, peak, convert_coordinate))
                this.add_listener_poly()
                this.add_lines(svg, peaks, convert_coordinate)
                this.add_listener_line()
            },
            legend(svg, {
                color,
                title,
                tickSize = 6,
                width = 320,
                height = 44 + tickSize,
                marginTop = 18,
                marginRight = 0,
                marginBottom = 16 + tickSize,
                marginLeft = 0,
                ticks = width / 64,
                tickFormat,
                tickValues,
                rotation = 0,
                translate_x = 0,
                translate_y = 0
            } = {}) {
                const bar_g = svg.append('g')
                bar_g.attr("width", width)
                    .attr("height", height)
                    .attr("viewBox", [0, 0, width, height])
                    .style("overflow", "visible")
                    .style("display", "block");

                let tickAdjust = g => g.selectAll(".tick line").attr("y1", marginTop + marginBottom - height);
                let x;

                // Continuous
                if (color.interpolate) {
                    const n = Math.min(color.domain().length, color.range().length);

                    x = color.copy().rangeRound(d3.quantize(d3.interpolate(marginLeft, width - marginRight), n));

                    bar_g.append("image")
                        .attr("x", marginLeft)
                        .attr("y", marginTop)
                        .attr("width", width - marginLeft - marginRight)
                        .attr("height", height - marginTop - marginBottom)
                        .attr("preserveAspectRatio", "none")
                        .attr("xlink:href", this.ramp(color.copy().domain(d3.quantize(d3.interpolate(0, 1), n))).toDataURL());
                }

                // Sequential
                else if (color.interpolator) {
                    x = Object.assign(color.copy()
                        .interpolator(d3.interpolateRound(marginLeft, width - marginRight)), {
                        range() {
                            return [marginLeft, width - marginRight];
                        }
                    });

                    bar_g.append("image")
                        .attr("x", marginLeft)
                        .attr("y", marginTop)
                        .attr("width", width - marginLeft - marginRight)
                        .attr("height", height - marginTop - marginBottom)
                        .attr("preserveAspectRatio", "none")
                        .attr("xlink:href", this.ramp(color.interpolator()).toDataURL());

                    // scaleSequentialQuantile doesn’t implement ticks or tickFormat.
                    if (!x.ticks) {
                        if (tickValues === undefined) {
                            const n = Math.round(ticks + 1);
                            tickValues = d3.range(n).map(i => d3.quantile(color.domain(), i / (n - 1)));
                        }
                        if (typeof tickFormat !== "function") {
                            tickFormat = d3.format(tickFormat === undefined ? ",f" : tickFormat);
                        }
                    }
                }

                // Threshold
                else if (color.invertExtent) {
                    const thresholds = color.thresholds ? color.thresholds() // scaleQuantize
                        :
                        color.quantiles ? color.quantiles() // scaleQuantile
                            :
                            color.domain(); // scaleThreshold

                    const thresholdFormat = tickFormat === undefined ? d => d :
                        typeof tickFormat === "string" ? d3.format(tickFormat) :
                            tickFormat;

                    x = d3.scaleLinear()
                        .domain([-1, color.range().length - 1])
                        .rangeRound([marginLeft, width - marginRight]);

                    bar_g.append("g")
                        .selectAll("rect")
                        .data(color.range())
                        .join("rect")
                        .attr("x", (d, i) => x(i - 1))
                        .attr("y", marginTop)
                        .attr("width", (d, i) => x(i) - x(i - 1))
                        .attr("height", height - marginTop - marginBottom)
                        .attr("fill", d => d);

                    tickValues = d3.range(thresholds.length);
                    tickFormat = i => thresholdFormat(thresholds[i], i);
                }

                // Ordinal
                else {
                    x = d3.scaleBand()
                        .domain(color.domain())
                        .rangeRound([marginLeft, width - marginRight]);

                    bar_g.append("g")
                        .selectAll("rect")
                        .data(color.domain())
                        .join("rect")
                        .attr("x", x)
                        .attr("y", marginTop)
                        .attr("width", Math.max(0, x.bandwidth() - 1))
                        .attr("height", height - marginTop - marginBottom)
                        .attr("fill", color);

                    tickAdjust = () => { };
                }

                bar_g.append("g")
                    .attr("transform", `translate(0,${height - marginBottom})`)
                    .call(d3.axisBottom(x)
                        .ticks(ticks, typeof tickFormat === "string" ? tickFormat : undefined)
                        .tickFormat(typeof tickFormat === "function" ? tickFormat : undefined)
                        .tickSize(tickSize)
                        .tickValues(tickValues))
                    .call(tickAdjust)
                    .call(g => g.select(".domain").remove())
                    .call(g => g.append("text")
                        .attr("x", marginLeft)
                        .attr("y", marginTop + marginBottom - height - 6)
                        .attr("fill", "currentColor")
                        .attr("text-anchor", "start")
                        .attr("font-weight", "bold")
                        .text(title));
                bar_g.attr("transform", `rotate(${rotation}) translate(${translate_x},${translate_y})`)
                return bar_g;
            },
            ramp(color, n = 256) {
                let canvas = document.createElement('canvas');
                canvas.width = n;
                canvas.height = 1;
                const context = canvas.getContext("2d");
                for (let i = 0; i < n; ++i) {
                    context.fillStyle = color(i / (n - 1));
                    context.fillRect(i, 0, 1, 1);
                }
                return canvas;
            },
            add_lines(svg, peaks, coordinate_convert_fun){
                for (let step = 1; step < peaks.length; step++) {
                    for (let i = 0; i + step < peaks.length; i++) {
                        this.add_line(svg, peaks[i], peaks[i + step], i, i + step, coordinate_convert_fun)
                    }
                }
            },
            add_line(svg, pk1_items, pk2_items, first_index, second_index, coordinate_convert_fun) {
                let line_name = "peak_line_" + first_index + second_index
                //const pk1_items = peak1.split(','), pk2_items = peak2.split(',')
                let x1 = pk1_items[0] * 1, y1 = pk1_items[1] * 1, x2 = pk2_items[0] * 1, y2 = pk2_items[1] * 1
                let coor = coordinate_convert_fun([x1, y1])
                x1 = coor[0]
                y1 = coor[1]
                coor = coordinate_convert_fun([x2, y2])
                x2 = coor[0]
                y2 = coor[1]
                const v_dis = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2))
                if (v_dis > 100) {
                    let cut_dist = 10
                    const vx12 = cut_dist * (x1 - x2) / v_dis, vy12 = cut_dist * (y1 - y2) / v_dis
                    svg.append("line")
                        .attr("x1", x1)
                        .attr("y1", y1)
                        .attr("x2", x2)
                        .attr("y2", y2)
                        .attr("id", line_name)
                        .attr("stroke-dasharray", "10,10")
                        .attr("stroke-linecap", "round")
                        .attr("stroke-width", 3)
                        // .attr("line_info", `${x1-x2},${y1-y2},${pk1_items[2]*1.-pk2_items[2]*1.}`)
                        .attr("stroke", "#044B9466");
                    svg.append("line")
                        .attr("x1", x1 + vx12)
                        .attr("y1", y1 + vy12)
                        .attr("x2", x2 - vx12)
                        .attr("y2", y2 - vx12)
                        .attr("class", "peak_line")
                        .attr("for_line", line_name) //表示与哪条线关联
                        .attr("line_info", `${first_index + 1},${second_index + 1},${pk1_items[0] * 1. - pk2_items[0] * 1.},${pk1_items[1] * 1. - pk2_items[1] * 1.},${pk1_items[2] * 1. - pk2_items[2] * 1.}`)
                        .attr("stroke-width", 10)
                        .attr("stroke", "rgba(255,255,255,0)");
                } else {
                    svg.append("line")
                        .attr("x1", x1)
                        .attr("y1", y1)
                        .attr("x2", x2)
                        .attr("y2", y2)
                        .attr("id", line_name)
                        .attr("stroke-dasharray", "10,10")
                        .attr("stroke-linecap", "round")
                        .attr("stroke-width", 3)
                        .attr("class", "peak_line")
                        .attr("line_info", `${first_index + 1},${second_index + 1},${pk1_items[0] * 1. - pk2_items[0] * 1.},${pk1_items[1] * 1. - pk2_items[1] * 1.},${pk1_items[2] * 1. - pk2_items[2] * 1.}`)
                        // .attr("line_info", `${x1-x2},${y1-y2},${pk1_items[2]*1.-pk2_items[2]*1.}`)
                        .attr("stroke", "#044B9466");
                }
            },
            add_listener_line() {
                d3.selectAll(".peak_line").on("mouseover", function () {
                    let tooltip = d3.select("div#hx_tooltip")
                    let pk_object = d3.select(this)
                    let line_id = pk_object.attr("for_line")
                    let line_object = pk_object
                    if (line_id != null) line_object = d3.select("#" + line_id)
                    line_object.attr("stroke", "#044b94");
                    // const pt = pk_object.attr('points').split(' ')[0].split(',')
                    // const infos = pk_object.attr('hx_data').split(',')
                    let infos = pk_object.attr("line_info").split(",")
                    const pt_left = Math.round((pk_object.attr("x1") * 1 + pk_object.attr("x2") * 1) / 2) + 25
                    const pt_top = Math.round((pk_object.attr("y1") * 1 + pk_object.attr("y2") * 1) / 2) + 20
                    return tooltip.style("visibility", "visible")
                        .style("top", pt_top + "px")
                        .style("left", pt_left + "px")
                        .html(`峰${infos[0]}-${infos[1]}间信息<br>Ex差: ${infos[2]}nm<br>Em差: ${infos[3]}nm<br>峰间差: ${(infos[4] * 1.).toFixed(5)}`);
                }).on("mouseout", function () {
                    let tooltip = d3.select("div#hx_tooltip")
                    let pk_object = d3.select(this)
                    let line_id = pk_object.attr("for_line")
                    let line_object = pk_object
                    if (line_id != null) line_object = d3.select("#" + line_id)
                    line_object.attr("stroke", "#044B9466");
                    return tooltip.style("visibility", "hidden");
                })
            },
            add_polygon(svg, peak_nums, coordinate_convert_fun, index) {
                //const peak_nums = peak_str.split(',')
                const peak_str = peak_nums.join(',');
                const coor = coordinate_convert_fun([peak_nums[0] * 1, peak_nums[1] * 1])
                const x_cor = coor[0], y_cor = coor[1]
                svg.append('polygon')
                    .attr('points', `${x_cor},${y_cor - 10} ${x_cor - 8.66},${y_cor + 5} ${x_cor + 8.66},${y_cor + 5}`)
                    .attr('fill', "none")
                    .attr('class', 'peak_poly')
                    .attr('hx_data', `峰${index + 1},${peak_str}`)
                    .attr('stroke', 'red')
                    .attr('stroke-width', '3');
            },
            add_listener_poly() {
                d3.selectAll(".peak_poly")
                    .on("mouseover", function () {
                        let tooltip = d3.select("div#hx_tooltip")
                        let pk_object = d3.select(this)
                        pk_object.style("fill", d3.select(this).attr('stroke'))
                            .attr('fill-opacity', 0.3);
                        const pt = pk_object.attr('points').split(' ')[0].split(',')
                        const infos = pk_object.attr('hx_data').split(',')
                        const pt_top = pt[1] * 1 + 25
                        const pt_left = pt[0] * 1 + 20
                        return tooltip.style("visibility", "visible")
                            .style("top", pt_top + "px")
                            .style("left", pt_left + "px")
                            .html(`${infos[0]}<br>Em: ${infos[1]}nm<br>Ex: ${infos[2]}nm<br>Peak: ${(infos[3] * 1.).toFixed(5)}`);
                    })
                    .on("mouseout", function () {
                        let tooltip = d3.select("div#hx_tooltip")
                        d3.select(this).style("fill", "none")
                            .attr('fill-opacity', 1);
                        return tooltip.style("visibility", "hidden");
                    });
            },
            add_tooltip() {
                d3.select("div#" + this.chartData.chartid)
                    .insert("div")
                    .style("position", "absolute")
                    .style("visibility", "hidden")
                    .style("background-color", "white")
                    .style("border", "solid")
                    .style("border-width", "1px")
                    .style("border-radius", "5px")
                    .style("padding", "10px")
                    .attr("id", "hx_tooltip")
                    .html("Empty");
            }
        }
    }
</script>

<style scoped>
</style>